// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2oQOl","colMin":"styles_colMin__3GZcv"};